import React from "react";
import { motion } from "framer-motion";
import { Compass } from "lucide-react";
import DataCloudTrackCard from "@/components/DataCloudTrackCard";
import SfmcTrackCard from "@/components/SfmcTrackCard";
import McNextTrackCard from "@/components/McNextTrackCard";
import AdminDevTrackCard from "@/components/AdminDevTrackCard";
import ServiceNowTrackCard from "@/components/ServiceNowTrackCard";

const item = { hidden: { opacity: 0, y: 14 }, visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] } } };

export default function TrackChooserSection({ dataCloudStats }) {
  return (
    <motion.div variants={item} className="mb-6" data-testid="dashboard-track-chooser-section">
      <div className="flex items-center gap-2 mb-3">
        <Compass className="w-4 h-4 text-[#8993ab]" />
        <span className="text-xs font-bold uppercase tracking-wider text-[#8993ab]">Choose Your Track</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
        <DataCloudTrackCard stats={dataCloudStats} />
        <SfmcTrackCard />
        <McNextTrackCard />
        <AdminDevTrackCard />
        <ServiceNowTrackCard />
      </div>
    </motion.div>
  );
}
